import React from 'react'
import './EventItem.style.scss'
import {fill} from '../../../utils/ApColor'
import StampTypeEvent from './StampTypeEvent'
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord'

export default function EventItem({
  data,
  eventColor,
  title,
  onClickEvent = () => {},
  current_date,
  this_start_date,
  this_end_date,
  week_day,
  preDayEvents,
}) {
  var position_zindex =
    this_start_date === this_end_date ||
    (week_day === 0 && current_date === this_end_date) ||
    (current_date === this_end_date && preDayEvents?.length && preDayEvents.indexOf(data) === -1)
  var border_ =
    current_date === this_start_date ||
    week_day === 0 ||
    (preDayEvents?.length && preDayEvents.indexOf(data) === -1)

  const prepareValue = val => {
    let display_value
    if ((val !== null && val !== undefined && val.length > 0) || typeof val == 'number') {
      display_value = `${val},`
    } else {
      display_value = ''
    }
    return display_value
  }
  var show_title = current_date === this_start_date || current_date === this_end_date ? title : ''
  const first_name = prepareValue(data.display_name_first)
  const second_name = prepareValue(data.display_with_secondary)
  const third_name = prepareValue(data.display_name_third)
  const full_value = `${first_name} ${second_name} ${third_name}`.replace(/,\s*$/, '')

  return (
    <div
      className=" event-item "
      style={{flexBasis: '100%', maxWidth: '100%', color: eventColor}}
      onClick={() => onClickEvent(data)}
    >
      {data.is_stamp ? (
        show_title && (
          <div tabindex="0" className="ap-ellipsis">
            <div className="event-header sharable-event" title={title}>
              <FiberManualRecordIcon className="circle-icon" />
              &nbsp;
              <span className="ap-typography ap-typography--sm ap-ellipsis vertical-text-top">
                {full_value.length > 25 ? `${full_value.substring(0, 25)}...` : full_value}
              </span>
            </div>
          </div>
        )
      ) : (
        <StampTypeEvent
          eventColor={eventColor}
          title={title}
          position_zindex={position_zindex}
          border_={border_}
        />
      )}
    </div>
  )
}

export const hexToRgbA = (hex, op) => {
  var c
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('')
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]]
    }
    c = '0x' + c.join('')
    return `rgba(${[(c >> 16) & 255, (c >> 8) & 255, c & 255]},${op})`
  }
  throw new Error('Bad Hex')
}
